import blog1 from '../img/blogs/tenor.gif';
import blog2 from '../img/blogs/jstips-animation.gif';
import blog3 from '../img/blogs/content_heart-react.gif';
import blog4 from '../img/blogs/blog4.jpg';

const blogs = [
    {
        id: 1,
        image: blog1,
        title: 'Some things about JavaScript',
        link: 'https://ahad-aiman2.medium.com/some-things-about-javascript-3b171a21fa67',
        date : '5',
        month: 'May',
        year: '2021'
    },
    {
        id: 2,
        image: blog2,
        title: 'Few important Questions in JavaScript and ES6',
        link: 'https://ahad-aiman2.medium.com/few-important-questions-in-javascript-and-es6-cb4d84d015a1',
        date : '7',
        month: 'May',
        year: '2021'
    },
    {
        id: 3,
        image: blog3,
        title: 'Few Core Concepts in React JS',
        link: 'https://ahad-aiman2.medium.com/few-core-concepts-in-react-js-56350068ecf3',
        date : '8',
        month: 'May',
        year: '2021'
    },
    {
        id: 4,
        image: blog4,
        title: 'Some important interview Question in JavaScript and ES6',
        link: 'https://ahad-aiman2.medium.com/some-important-interview-question-in-javascript-and-es6-f58d8819f569m/',
        date : '10',
        month: 'May',
        year: '2021'
    }
   
];

export default blogs;